// initial state
import {
  MbeServiceDTO,
  ShipmentDetailsOutputDTO,
  SubcountryDTO,
  ZonosCalculateResponseDTO,
  ZonosCalculateResponseItemDTO
} from "@/model/data.model";
import { cloneDeep } from "lodash";

const state = {
  mbeServices: [] as MbeServiceDTO[],
  visibleMBEServices: [] as MbeServiceDTO[],
  zonosInvalidItems: [] as ZonosCalculateResponseItemDTO[],
  zonosCalculateResponse: null as ZonosCalculateResponseDTO | null,
  lastDetails: null as ShipmentDetailsOutputDTO | null,
  enableTaxDutySection: false
};

// getters
const getters = {
  zonosInvalidItems: state => state.zonosInvalidItems,
  zonosCalculateResponse: state => state.zonosCalculateResponse,
  lastDetails: state => state.lastDetails,
  enableTaxDutySection: state => state.enableTaxDutySection,
  mbeServices: state => state.mbeServices,
  visibleMBEServices: state => state.visibleMBEServices
};

// actions
const actions = {
  async getMacroareaForContact(
    { dispatch, rootGetters },
    { zipCode, countryId }
  ): Promise<string> {
    const storeZipCode = rootGetters["customer/storeAddresses"][0].zipCode;
    const storeIsoCode = rootGetters["customer/storeAddresses"][0].countryId;
    let result = "NATIONAL";
    await dispatch(
      "cachemod/getSubcountries",
      {
        countryId: countryId,
        zipcode: zipCode,
        storeZipCode: storeZipCode,
        storeIsoCode: storeIsoCode
      },
      { root: true }
    ).then((res: SubcountryDTO[]) => {
      if (res !== undefined) {
        if (res.length !== 0) {
          result = res[0].macroareaName;
        }
      }
    });
    return Promise.resolve(result);
  }
};

// mutations
const mutations = {
  setMbeServices: (state: any, services: MbeServiceDTO[]) => {
    state.mbeServices = services;
  },
  setVisibleMbeServices: (state: any, services: MbeServiceDTO[]) => {
    state.visibleMBEServices = services;
  },
  enableTaxDutySection: (state: any, status: boolean) => {
    state.enableTaxDutySection = status;
  },
  setZonosInvalidItems(state, items: ZonosCalculateResponseItemDTO[]) {
    state.zonosInvalidItems = cloneDeep(items);
  },
  setLastDetails(state, lastDetails: ShipmentDetailsOutputDTO | null) {
    if (lastDetails) {
      state.lastDetails = Object.assign({}, lastDetails);
    } else {
      state.lastDetails = null;
    }
  },
  setZonosCalculateResponse(state, object: ZonosCalculateResponseDTO | null) {
    state.zonosCalculateResponse = object !== null ? cloneDeep(object) : null;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
